import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebaseConfig';

export interface LegacyVaultItem {
    id: string;
    name: string;
    price: number;
    description: string;
    features: string[];
    files: string[] | null;
    createdAt: string;
    order: number;
    hasAccess: boolean;
}

export interface FetchLegacyVaultsResponse {
    items: LegacyVaultItem[];
}

export interface CreateLVPaymentSessionRequest {
    itemId: string;
    userId: string;
    successUrl: string;
    cancelUrl: string;
}

export interface CreateLVPaymentSessionResponse {
    url: string;
}

const fetchLegacyVaults = httpsCallable<{ userId: string }, FetchLegacyVaultsResponse>(functions, 'fetchLegacyVaults');

const createLVPaymentSession = httpsCallable<CreateLVPaymentSessionRequest, CreateLVPaymentSessionResponse>(functions, 'createLVPaymentSess');

export const legacyVaultService = {
    async fetchLegacyVaults(userId: string): Promise<LegacyVaultItem[]> {
        try {
            const result = await fetchLegacyVaults({ userId });
            return result.data.items;
        } catch (error) {
            console.error('Error fetching legacy vaults:', error);
            throw error;
        }
    },

    async createPaymentSession(itemId: string, userId: string, successUrl: string, cancelUrl: string): Promise<string> {
        try {
            const result = await createLVPaymentSession({
                itemId,
                userId,
                successUrl,
                cancelUrl,
            });
            return result.data.url;
        } catch (error) {
            console.error('Error creating payment session:', error);
            throw error;
        }
    },
};
